export const PERMISSIONS = {
  FULL_ACCESS: "Administrador - Acesso total",
  MANAGE_FINANCIAL_SUPPORT: "Crédito - Apoio Financeiro",
  MANAGE_FINANCIAL_PROPOSAL: "Crédito - Proposta Apoio Financeiro",
  MODIFY_FINANCIAL_PROPOSAL: "Crédito - Gerenciar Proposta Apoio Financeiro",
  APROVEC: "Aprovec",
};
